// CANONICAL COPY (GH #7115). src/constants/obligations/obl-isms-context-scope.js re-exports this file so the browser and the
// Function App share one compliance engine — one definition of "compliant". Edit here, never there.
'use strict';

module.exports = {
  id: 'obl-isms-context-scope',
  title: 'Review ISMS context, scope and stakeholder requirements',
  description:
    'Determine external and internal issues relevant to the ISMS, the needs and expectations of interested parties, and the scope and boundaries of the management system. Review is required whenever business context or interested-party requirements change, and at planned intervals.',
  category: 'governance',
  scfIds: ['SCF-MSS-001'],
  cadence: { frequency: '1y', anchor: 'domain' },
  strategy: 'all',
  fulfilmentCriteria: [
    { type: 'document-published', description: 'ISMS context and scope statement is published' },
    { type: 'document-approved', description: 'Scope statement has been approved' },
    { type: 'document-within-sla', description: 'Context and scope review is not overdue' },
  ],
  domainActions: [{ type: 'approve-document', label: 'Approve Document' }],
};
